import React from 'react';
import { IconButton } from '@mui/material';
import { LoopRounded } from '@mui/icons-material';
import { Tooltip } from 'src/shared/ui/tooltip';
import { Typography } from '@mui/material';
import { usePlayerContext } from '../../context/player-context';

export const LoopControls: React.FC = () => {
  const { loopEnabled, loopStart, loopEnd, formatTime, openLoopModal, clearLoop } =
    usePlayerContext();

  // Only show if loop is enabled
  if (!loopEnabled) {
    return null;
  }

  return (
    <div
      className="absolute flex items-center px-2 py-1 space-x-2 bg-black rounded-md top-4 right-4 bg-opacity-60 z-[1000]"
      style={{ pointerEvents: 'auto' }}
    >
      <Typography variant="caption" className="text-white">
        Loop: {formatTime(loopStart || 0)} - {formatTime(loopEnd || 0)}
      </Typography>

      <Tooltip content={<Typography variant="button-s">Modifica Loop</Typography>} portal>
        <IconButton
          size="small"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openLoopModal();
          }}
          className="text-white hover:text-primary-light"
        >
          <LoopRounded fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip content={<Typography variant="button-s">Rimuovi Loop</Typography>} portal>
        <IconButton
          size="small"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            clearLoop();
          }}
          className="text-white hover:text-primary-light"
        >
          <span className="text-sm">×</span>
        </IconButton>
      </Tooltip>
    </div>
  );
};
